import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import Nav from "../list/Nav";
import "swiper/css";
import "swiper/css/navigation";

import importImage from "../list/ImportImage";
import data from "../../data.json";

const Wrapper = styled.div`
  padding: 100px;
  display: flex;
  justify-content: center;
  background: white;
  color: black;
`;

const ContentArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  max-width: 1080px;
  width: 100%;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ImageBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FoodImage = styled.img`
  width: 100%;
  max-width: 420px;
  height: 280px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 16px;
`;

const ThumbList = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

const Thumb = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 6px;
  cursor: pointer;
  object-fit: cover;
  border: 2px solid transparent;
  &:hover {
    border-color: #333;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  font-size: 28px;
  padding-bottom: 12px;
  border-bottom: 2px solid #ccc;
`;

const Price = styled.p`
  font-size: 20px;
color: #666;
  margin: 8px 0;
`;

const Desc = styled.p`
  font-size: 18px;
  line-height: 1.5;
  padding: 20px;
  background-color: #f7f7f7;
`;



const Section = styled.section`
  margin-top: 40px;
  max-width: 1080px;
  width: 100%;
`;

const SectionTitle = styled.h3`
  font-size: 22px;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #ccc;
`;


function PostViewPage() {
  const navigate = useNavigate();
  const { postId } = useParams();
  const post = data.find((item) => item.id == postId);

 
const [imageSrc, setImageSrc] = useState("");
 
const [thumbs, setThumbs] = useState([]);
const isVideo = (file) => {
  return file.endsWith(".mp4");
};

useEffect(() => {
  if (Array.isArray(post.images)) {
    setImageSrc(require(`../images/${post.images[0]}`));  
    setThumbs(post.images);  
  } else {
    setImageSrc(require(`../images/${post.images}`));
    setThumbs([post.images]);
  }
}, [post]);


  return (
    <>
        <Nav 
    onClick={() => navigate("/")} 
    style={{ backgroundColor: "black",
      paddingBottom: "20px",
      color: "transparent"
    }}
  />
    <Wrapper>
      <div style={{ width: "100%" }}>
  
        <ContentArea>
          {/* 왼쪽: 이미지 + 썸네일 */}
          <ImageBox>
  {isVideo(imageSrc) ? (
    <video
      key={imageSrc}  // ensure re-render when source changes
      src={imageSrc}
      controls
      autoPlay
      loop
      muted
      style={{
        width: "100%",
        maxWidth: "420px",
        height: "280px",
        borderRadius: "12px",
        marginBottom: "16px",
        objectFit: "cover",
      }}
    />
  ) : (
    <FoodImage src={imageSrc} alt={post.title} />
  )}

  {/* Thumbnails */}
  <ThumbList>
  {thumbs.map((src, idx) => {
    const file = require(`../images/${src}`);
    const isVid = isVideo(src);

    return isVid ? (
      <video
        key={idx}
        src={file}
        muted
        loop
        playsInline
        autoPlay
        style={{
          width: "70px",
          height: "70px",
          borderRadius: "6px",
          objectFit: "cover",
          cursor: "pointer",
          border: "2px solid transparent",
        }}
        onClick={() => setImageSrc(file)}
      />
    ) : (
      <Thumb
        key={idx}
        src={file}
        onClick={() => setImageSrc(file)}
      />
    );
  })}
</ThumbList>

</ImageBox>

    
          <InfoBox>

            <Title>{post.title}</Title>
            <Price>{post.subtitle}</Price>
            <Desc>{post.content}</Desc>
 
          </InfoBox>
        </ContentArea>


        <Section>
          <SectionTitle>Other Menu</SectionTitle>
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={16}
            slidesPerView={4}
            navigation
            loop
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            style={{ paddingBottom: "30px" }}
          >
            {data
              .filter((item) => item.id != post.id) // 현재 메뉴 제외
              .map((item) => (
                <SwiperSlide key={item.id}>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(`/post/${item.id}`)}
                  >
                    <img
                      src={require(`../images/${item.images[0]}`)}
                      alt={item.title}
                       style={{
                            width: "220px",       
                            height: "180px", 
                            objectFit: "cover",
                            borderRadius: "8px",
                            margin: "0 auto",    
                            display: "block",
                      }}
                    />
                    <p style={{ marginTop: "8px", textAlign: "center" }}>
                      {item.title}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </Section>
      </div>
    </Wrapper>
     </>
  );
}

export default PostViewPage;
